<template>
    <div v-if="text && text.trim()" class="marquee-container" ref="container">
      <div class="marquee-content" ref="content" :style="{ left: position + 'px' }">
        {{ text }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        text: "", // 初始为空，组件将不显示
        position: 0,
        animationId: null,
        speed: 0.3,
        requestUrl: "",
        dept: "",
        compid: 0,
        fetchInterval: null, // 定时器引用
        lastFetchTime: null // 最后获取时间
      }
    },
    created() {
      this.requestUrl = window.localStorage.getItem('requestUrl')
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      this.initDataFetch()
    },
    mounted() {
      if (this.text && this.text.trim()) {
        this.startAnimation()
      }
    },
    beforeDestroy() {
      this.stopAnimation()
      this.clearFetchInterval()
    },
    methods: {
      // 初始化数据获取定时器
      initDataFetch() {
        // 立即获取一次数据
        this.getkgfun()
        
        // 设置每10分钟获取一次数据
        this.fetchInterval = setInterval(() => {
          this.getkgfun()
        }, 10 * 60 * 1000) // 10分钟
      },
      
      // 清除定时器
      clearFetchInterval() {
        if (this.fetchInterval) {
          clearInterval(this.fetchInterval)
          this.fetchInterval = null
        }
      },
      
      startAnimation() {
        const containerWidth = this.$refs.container.offsetWidth
        const contentWidth = this.$refs.content.offsetWidth
        
        this.position = containerWidth
        
        const animate = () => {
          this.position -= this.speed
          
          if (this.position < -contentWidth) {
            this.position = containerWidth
          }
          
          this.animationId = requestAnimationFrame(animate)
        }
        
        this.animationId = requestAnimationFrame(animate)
      },
      
      stopAnimation() {
        if (this.animationId) {
          cancelAnimationFrame(this.animationId)
          this.animationId = null
        }
      },
      
      // 更新文本内容
      updateText(newText) {
        const wasEmpty = !this.text || !this.text.trim()
        this.text = newText || ""
        
        if (this.text && this.text.trim()) {
          if (wasEmpty) {
            this.$nextTick(() => {
              this.startAnimation()
            })
          }
        } else {
          this.stopAnimation()
        }
      },
      
      // 获取后台数据
      getkgfun() {
        this.lastFetchTime = new Date()
        console.log(`获取数据，时间: ${this.lastFetchTime.toLocaleTimeString()}`)
        
        this.axios({
          method: 'post',
          url: `${this.requestUrl}/admin.php/Bigsreen/UrgeOrderfun?&compid=${this.compid}&dept=${this.dept}`
        })
        .then((response) => {
          console.log("UrgeOrderfun 返回数据:", response.data)
          
          // 更新文本内容
          this.updateText(response.data)
          
          // 如果内容变化，重新计算动画
          if (this.text && this.text.trim()) {
            this.$nextTick(() => {
              this.stopAnimation()
              this.startAnimation()
            })
          }
        })
        .catch((error) => {        
          console.error("获取数据失败:", error)
          // 可以在这里添加重试逻辑
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .marquee-container {
    width: 100%;
    overflow: hidden;
    position: relative;
    height: 40px;
    line-height: 40px;
    background-color: rgba(0, 0, 0, 0.2); /* 添加背景色提高可读性 */
  }
  
  .marquee-content {
    position: absolute;
    white-space: nowrap;
    color: white;
    font-size: 40px; /* 从40px调整为16px更合理 */
    height: 40px;
    line-height: 40px;
    font-weight: bold; /* 加粗文字 */
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5); /* 添加文字阴影提高可读性 */
  }
  </style>


// WEBPACK FOOTER //
// src/views/workroomdp/components/Auotsrceen.vue